import React from 'react'
import { Link } from 'react-router-dom'

export default function FAQ() {
    return (
        <div>
            <div className="dempp" style={{ backgroundImage: "url('/assets/img/hero/ImportedPhoto_1722864109271.jpg')", backgroundSize: 'cover', backgroundPosition: ' center' }}>
                <h2>FAQs</h2>
                <p> <Link onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
                    to={'/'} style={{ color: 'white' }}>Home </Link> / FAQs </p>
            </div>
            <div className="container my-5">
                <div className="row">
                    <div className="container">
                        <div className="dance bgring1">
                            <div className="row">
                                <div className="col-md-5">
                                    <div className="tab-img1">
                                        <video controls style={{ height: "300px", width: "100%" }} controlsList="nodownload">
                                            <source src="assets/img/faq/registartion.mp4" type="video/mp4" />
                                            <source src="movie.ogg" type="video/ogg" />
                                        </video>
                                    </div>
                                </div>
                                <div className="col-md-7">
                                    <div className="tab-text1 my-5">
                                        <h4 id='make-purchases'>How to register/make purchases via website.</h4>
                                        <h6 className='mt-4'> 1. Register</h6>
                                        <p>Sign up on the website by providing your details (email, name, etc.) and submit the form.</p>
                                        <h6 className='mt-4'>2. Login</h6>
                                        <p>Enter your Mail ID and the password you created for registration. Click on Login.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container my-5">
                <div className="row">
                    <div className="container">
                        <div className="dance bgring1">
                            <div className="row">
                                <div className="col-md-5">
                                    <div className="tab-img1">
                                        <video controls style={{ height: "300px", width: "100%" }} controlsList="nodownload">
                                            <source src="assets/img/faq/purchese.mp4" type="video/mp4" />
                                            <source src="movie.ogg" type="video/ogg" />
                                        </video>
                                    </div>
                                </div>
                                <div className="col-md-7">
                                    <div className="tab-text1 my-5">
                                        <h4 id='make-payment'>How to book classes or workshops / how to make the purchase?</h4>

                                        <h6 className='mt-4'>3. Book Classes/Studio</h6>
                                        <p>Browse available classes, select one, and choose a date/time. Confirm your booking.</p>
                                        <h6 className='mt-4'>4. Make Purchases</h6>
                                        <p>Select the product or service you want, add to cart, and proceed to checkout to pay online/cash.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
